export const REAL_TIME = process.env.NODE_ENV === "STAGING" ? "60000" : "420000";
export const TIME_10_MIN = "600000";
export const TIME_30_MIN = "1800000";
export const TIME_1_HR = "3600000";
export const TIME_6_HR = "21600000";
export const TIME_12_HR = "43200000";
export const TIME_1_DAY = "86400000";
export const TIME_7_DAY = "604800000";
export const TIME_30_DAY = "2592000000";

// Flip protection constants  
export const FLIP_PROTECTION_SECONDS = 40;  // 40 seconds for flip protection
export const FLIP_PROTECTION_MS = FLIP_PROTECTION_SECONDS * 1000; // 40 seconds in milliseconds